let amplifyConfigured = false;

/**
 * Lazily configure Amplify on the client.
 *
 * Why: `aws-amplify` (and especially `@aws-amplify/ui-react`) is expensive to include
 * in the initial marketing bundle. We only configure Amplify when auth features are
 * actually needed (auth/profile/dashboard routes, auth UI pages, etc.).
 */
export async function ensureAmplifyConfigured() {
  if (typeof window === 'undefined') return;
  if (amplifyConfigured) return;
  amplifyConfigured = true;

  const [{ Amplify }, { amplifyConfig }] = await Promise.all([
    import('aws-amplify'),
    import('@/config/amplify'),
  ]);

  Amplify.configure(amplifyConfig, { ssr: true });
}
